import React from 'react';

import { useIsExternalCollaborator } from '@confluence/external-collab-ui/entry-points/useIsExternalCollaborator.ts';
import { RESTRICTED_SPACE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component.ts';

import { RestrictedSpaceForGuest } from './RestrictedSpaceForGuest.tsx';
import { ShowSpinnerAfterDelay } from './ShowSpinnerAfterDelay.tsx';
import { RestrictedSpaceScreen } from './RestrictedSpaceScreen.tsx';
import { useIsAuthenticatedUnlicensedWithDirectAccess } from './request-license/useIsAuthenticatedUnlicensedWithDirectAccess.ts';

export const RestrictedSpace = ({ contentId }: { contentId?: string }) => {
	const { confluenceJoinability, identityLink, isDomainAccessLoading } =
		useIsAuthenticatedUnlicensedWithDirectAccess({});

	const { isExternalCollaborator } = useIsExternalCollaborator();

	if (isDomainAccessLoading) {
		return <ShowSpinnerAfterDelay />;
	}

	if (isExternalCollaborator) {
		return <RestrictedSpaceForGuest />;
	}

	return (
		<>
			<ExperienceStart name={RESTRICTED_SPACE_EXPERIENCE} />
			<RestrictedSpaceScreen
				contentId={contentId}
				confluenceJoinability={confluenceJoinability}
				identityLink={identityLink}
			/>
		</>
	);
};
